import { jsx as c } from "react/jsx-runtime";
import { createContext as p, useEffect as a } from "react";
import { i as e } from "./index-b195b7ae.js";
import "./dataTable.js";
import "./datePicker.js";
import "./dropdownMenuBase.js";
import "./searchInputLocation.js";
import "./components.js";
import "./en.js";
import "./i18nInstance-f01879af.js";
e.init({
  nsSeparator: !1
});
const f = p({
  language: "en",
  translations: {}
}), O = ({ children: m, language: r, translations: n, resources: o }) => (a(() => {
  const t = r || e.language;
  e.changeLanguage(t);
}, [r]), a(() => {
  var i;
  const t = r || e.language;
  !n || ((i = Object.keys(n)) == null ? void 0 : i.length) === 0 || e.addResourceBundle(t, "translation", n, !0, !0);
}, [r, n]), a(() => {
  var t;
  !o || ((t = Object.keys(o)) == null ? void 0 : t.length) === 0 || Object.entries(o).forEach(([i, u]) => {
    e.addResourceBundle(i, "translation", u.translation, !0, !0);
  });
}, [o]), /* @__PURE__ */ c(f.Provider, { value: { language: r, translations: n, resources: o }, children: m }));
export {
  f as TranslationContext,
  O as TranslationProvider
};
